export function EmptyState({ title = "Rien à afficher", sub = "Ajustez vos filtres ou revenez plus tard." }) {
  return (
    <div className="state">
      <div className="ico">
        <i className="fa-regular fa-folder-open"></i>
      </div>
      <h4>{title}</h4>
      <div>{sub}</div>
    </div>
  );
}

export default EmptyState;
